export default {
  'account': 'Account',
  'app.menu.logout': 'Logout',
  'app.menu.messages': 'Messages',
  'app.menu.notifications': 'Notifications',
  'app.menu.profile': 'Profile',
  'app.name': 'Nut Nut',
  'app.signIn': 'Sign In',
  'app.title': 'Nut Nut',
  'camera.title': 'Take photo',
  'diary': 'Diary',
  'diary.activity.add.form.date': 'Date',
  'diary.activity.add.form.description': 'Description',
  'diary.activity.add.form.duration': 'Duration',
  'diary.activity.add.form.intensity': 'Intensity',
  'diary.activity.add.form.time': 'Time',
  'diary.activity.add.form.type': 'Type',
  'diary.activity.add.form.type.BASKETBALL': 'Basketball',
  'diary.activity.add.form.type.BIKE': 'Bike',
  'diary.activity.add.form.type.DANCE': 'Dance',
  'diary.activity.add.form.type.FOOTBALL': 'Football',
  'diary.activity.add.form.type.GYM': 'Gym',
  'diary.activity.add.form.type.HANDBALL': 'Handball',
  'diary.activity.add.form.type.HOCKEY': 'Hockey',
  'diary.activity.add.form.type.RUN': 'Run',
  'diary.activity.add.form.type.SWIM': 'Swim',
  'diary.activity.add.form.type.VOLLEYBALL': 'Volleyball',
  'diary.activity.add.form.type.WALK': 'Walk',
  'diary.activity.add.title': 'Add new activity',
  'diary.drink.add.form.date': 'Date',
  'diary.drink.add.form.description': 'Description',
  'diary.drink.add.form.time': 'Time',
  'diary.drink.add.title': 'Add new drink',
  'diary.meal.add.form.date': 'Date',
  'diary.meal.add.form.description': 'Description',
  'diary.meal.add.form.time': 'Time',
  'diary.meal.add.title': 'Add new meal',
  'diary.meal.list.empty.hint': 'Start registering your daily routines',
  'diary.meal.list.empty.title': 'You haven\'t registered any meal today',
  'diary.meal.list.title': 'Nutritional Diary',
  'diary.measurement.add.form.biceps': 'Biceps',
  'diary.measurement.add.form.chest': 'Chest',
  'diary.measurement.add.form.date': 'Date',
  'diary.measurement.add.form.description': 'Description',
  'diary.measurement.add.form.hip': 'Hip',
  'diary.measurement.add.form.thigh': 'Thigh',
  'diary.measurement.add.form.time': 'Time',
  'diary.measurement.add.form.waist': 'Waist',
  'diary.measurement.add.form.weight': 'Weight',
  'diary.measurement.add.title': 'Add new measurement',
  'diary.wather.add.form.date': 'Date',
  'diary.wather.add.form.description': 'Description',
  'diary.wather.add.form.time': 'Time',
  'diary.wather.add.title': 'Add wather',
  'nav.account': 'account',
  'nav.diary': 'diary',
  'nav.settings': 'settings',
  'notauthorised.hint': 'You are not authorised to view this page',
  'notauthorised.title': 'Not Authorised',
  'settings': 'Settings'
};



// WEBPACK FOOTER //
// ./src/translations/en.ts